import { useEffect, useState } from 'react';
import api from '../services/api';

// Server-computed owner flag from /auth/me, so the owner's address never ships
// in the bundle. Presentation only: every owner endpoint re-checks it.
//
// One request per page load, shared: a screener with ten expanded rows renders
// ten news strips, and each asking /auth/me separately would be ten calls.
let pending = null;

export default function useIsOwner() {
  const [isOwner, setIsOwner] = useState(false);
  useEffect(() => {
    let cancelled = false;
    let hasToken = false;
    try { hasToken = !!localStorage.getItem('alphagrade_auth_token'); } catch { /* private mode */ }
    // Logged-out visitors (the landing page's grade card) cannot be the owner;
    // do not spend a request on a guaranteed 401.
    if (!hasToken) return undefined;
    if (!pending) {
      pending = api
        .get('/auth/me')
        .then(({ data }) => !!data?.is_owner)
        .catch(() => {
          pending = null; // signed out or offline: try again next mount
          return false;
        });
    }
    pending.then((v) => { if (!cancelled) setIsOwner(v); });
    return () => { cancelled = true; };
  }, []);
  return isOwner;
}
